import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'manual',
  template: require('./manual.component.html')
})

export class ManualComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.accountType = {
      stepTitle: 'Verify Your Bank Account',
      stepNum: '5'
    };
    this.nextBtnText = 'Next';
  }

  ngOnInit() {
    this.authenticated = this.flowManager.isAuthed;
    if (this.authenticated) {
      this.nextBtnText = 'Go to Accounts';
    }
  }

  buttonClick() {
    if (this.authenticated) {
      this.flowManager.ssoToAlly();
    } else {
      this.triggerLoading();
      this.router.navigate(['/credentials']);
    }
  }
}
